import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import AgentDeskIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/atendente'),
    name: 'agent_desk',
    component: AgentDeskIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
